// Shared pagination constants. Used by the AppPagination molecule's
// `perPageOptions` default AND any view that whitelists `?per_page=…`
// from the URL — so changing the set only requires one edit.
//
// Order matters for the dropdown rendering: smallest → largest.

export const PER_PAGE_OPTIONS = [25, 50, 100, 500]

// Convenience set for fast `validPerPages.has(n)` lookups in URL validators.
export const PER_PAGE_OPTIONS_SET = new Set(PER_PAGE_OPTIONS)
